var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlantDataPoint"},[_c('Icon',{attrs:{"name":_vm.icon}}),_c('div',{staticClass:"body"},[_c('h5',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"value"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }